import styled, { css } from 'styled-components'

export const StyledSearchResults = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(13, auto);
  width: 100%;
  max-width: 100%;
  min-height: 100vh;
  overflow: hidden;

  > ul {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: subgrid;
    grid-column: 1;
    grid-row: 1 / span 13;
    width: 100%;
    max-width: 100%;
    height: auto;
    overflow: hidden;
    min-width: 0;

    > li {
      grid-column: 1;
      grid-row: auto;
      min-width: 0;
      overflow: hidden;

      article {
        height: auto;
      }

      ${createNthChildCSS()}
    }
  }

  > button {
    grid-column: 1;
    grid-row: 3;
    display: flex;
    margin: 0 auto 1rem auto;
    border-radius: 4px;
    overflow: hidden;
    border: none;
    -webkit-appearance: none;
    padding: 0;

    picture {
      > * {
        width: 100%;
        height: 100%;
      }
    }
  }
`

function createNthChildCSS() {
  let styles = ''

  for (let i = 3; i < 13; i += 1) {
    styles += `
         &:nth-child(${i}) {
           grid-row: ${i + 1};
         }
       `
  }

  return css`
    ${styles}
  `
}
